export default {
    baseurl: "/api/"
}
